/**
 * Frontend mirror of backend/core/security/capabilities.py.
 *
 * Authorization responses contain effective capabilities, never raw roles.
 * Keep this catalog synchronized through the backend parity test.
 */
export const CAPABILITIES = {
    PRODUCT_READ: "product.read",
    PRODUCT_WRITE: "product.write",
    PRODUCT_ADMIN: "product.admin",
    SECTION_CODE: "section.code",
    SECTION_INTEGRATIONS: "section.integrations",
    ATLAS_QUERY: "atlas.query",
    GENERATION_EXECUTE: "generation.execute",
    EXPORT_BULK: "export.bulk",
    TENANT_TEAM_MANAGE: "tenant.team.manage",
    TENANT_IDENTITY_MANAGE: "tenant.identity.manage",
    TENANT_ADMIN_MANAGE: "tenant.admin.manage",
    SYSTEM_QUARANTINE_REMEDIATE: "system.quarantine.remediate"
} as const;

export type Capability = (typeof CAPABILITIES)[keyof typeof CAPABILITIES];

const CAPABILITY_VALUES = new Set<string>(Object.values(CAPABILITIES));

export function isCapability(value: unknown): value is Capability {
    return typeof value === "string" && CAPABILITY_VALUES.has(value);
}
